import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import EN from 'components/Community/CommunityNavigation/locales/CommunityNavigation_en_US.js';
import FR from 'components/Community/CommunityNavigation/locales/CommunityNavigation_fr_CA.js';

const { wrapHOC } = FrameworkUtils;
const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(EN, FR);

const fields = createSelector(
    createStructuredSelector({
        community: getTextFromResource(getText, 'community'),
        profile: getTextFromResource(getText, 'profile'),
        groups: getTextFromResource(getText, 'groups'),
        gallery: getTextFromResource(getText, 'gallery'),
        myGallery: getTextFromResource(getText, 'myGallery'),
        communityNavigation: getTextFromResource(getText, 'communityNavigation'),
        notificationsFeed: getTextFromResource(getText, 'notificationsFeed'),
        startAConversation: getTextFromResource(getText, 'startAConversation'),
        uploadToGallery: getTextFromResource(getText, 'uploadToGallery'),
        messages: getTextFromResource(getText, 'messages')
    }),
    localization => {
        return {
            localization
        };
    }
);

const functions = null;
const withCommunityNavigationProps = wrapHOC(connect(fields, functions));

export {
    withCommunityNavigationProps, fields, functions
};
